import { render, staticRenderFns } from "./manufacturing-material-brief.vue?vue&type=template&id=11e2af2c&scoped=true&"
import script from "./manufacturing-material-brief.vue?vue&type=script&lang=js&"
export * from "./manufacturing-material-brief.vue?vue&type=script&lang=js&"
import style0 from "./manufacturing-material-brief.vue?vue&type=style&index=0&id=11e2af2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e2af2c",
  null
  
)

export default component.exports